import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute , Router} from '@angular/router';
import { Response } from '@angular/http';

import { EventManager, AlertService, JhiLanguageService } from 'ng-jhipster';
import { DateConverterService } from '../shared/date/date-converter.service';
import { LoanOdAccounts } from './loan-od-accounts.model';
import { LoanOdRepaymentDto } from './loan-od-repayment-dto.model';
import { LoanOdAccountsService } from './loan-od-accounts.service';

@Component({
    selector: 'jhi-loan-od-accounts-security-deposit-refund',
    templateUrl: './loan-od-accounts-security-deposit-refund.component.html',
})
export class LoanOdAccountsSecurityDepositRefundComponent implements OnInit {

    loanOdAccounts: LoanOdRepaymentDto;
    subscription: any;
    proceedIsTrue: boolean;
    transactionTypeList: any[];
    dataIsAvailable: boolean ;
    isSuccessful: boolean;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private alertService: AlertService,
        private router: Router,
        private loanODAccountsService: LoanOdAccountsService,
        private eventManager: EventManager,
        private route: ActivatedRoute,
        private dateConverter: DateConverterService
    ) {
        // this.jhiLanguageService.setLocations(['loanOdAccounts']);
        this. proceedIsTrue = false;
        this. dataIsAvailable = false;
        this. isSuccessful = false;
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe((params) => {
            this.load(params['accountId']);
        });
    }

    load(accountId) {

        this.loanODAccountsService.securityDepositRefundEntry(accountId).subscribe((loanOdAccounts) => {
            this.loanOdAccounts = loanOdAccounts;
            this.loanOdAccounts.valueDate = this.dateConverter
                .fromServerToNgbDatePicker(this.loanOdAccounts.valueDate);
            if (this.loanOdAccounts.amount === undefined || this.loanOdAccounts.amount === null) {
                this.loanOdAccounts.amount = {
                    magnitude: 0,
                }
            }
        },
        (res) => {
            this.onError(res);
            this.router.navigate(['/loans/loan-od-accounts']);
        });
    }

    clear() {
        this.router.navigate(['/loans/loan-od-accounts']);
    }

    print() {
        window.print();
    }

    private onError(error) {
        try {
            const errorString = error.json().localizedMessage;
            if (errorString) {
                this.alertService.error('encoreclientApp.loanOdAccounts.serverError', { message: errorString });
            } else {
            this.alertService.error('encoreclientApp.loanOdAccounts.genericError');
            }
        } catch (exception) {
            try {
                const errorString = error.text();
                if (errorString) {
                    this.alertService.error('encoreclientApp.loanOdAccounts.serverError', { message: errorString });
                } else {
                    this.alertService.error('encoreclientApp.loanOdAccounts.genericError');
                }
            } catch (exception) {
                this.alertService.error('encoreclientApp.loanOdAccounts.genericError');
            }
        }
    }

    execute() {
        this.proceedIsTrue = true;
        this.loanOdAccounts.valueDate = this.dateConverter
            .fromNgbDatePickerToDateObject(this.loanOdAccounts.valueDate);
    }

    confirm() {
        this.loanODAccountsService.securityDepositRefundResult(this.loanOdAccounts)
            .subscribe(
                (res) => this.onConfirmSuccess(res),
                (res) => {
                    this.onError(res);
                    this.back();
                }
            );
    }

    private onConfirmSuccess(data) {
        this.isSuccessful = true;
        this.alertService.success('encoreclientApp.loanOdAccounts.securityDepositRefundSuccess'
            , { id: this.loanOdAccounts.accountId });
        this.router.navigate(['/loans/loan-od-accounts']);
    }
    back() {
        this.loanOdAccounts.valueDate = this.dateConverter
            .fromDateObjectToNgbDatePicker(this.loanOdAccounts.valueDate);
        this.proceedIsTrue = !this.proceedIsTrue;
    }

}
